import React from 'react';

/**
 * @returns {JSX.Element} Tick svg
 */
export default function Tick() {
  return (
    <svg
      width='12'
      height='9'
      viewBox='0 0 14 10'
      fill='none'
    >
      <path
        d='M1 5L5 9L13 1'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>

  );
}
